// extracted by mini-css-extract-plugin
module.exports = {"avatarSectionContainer":"_1yqX8-ri","avatarImageBlock":"_32klO087","avatarImage":"rnCZpGrM","socialLabels":"_1fUo9eBC","disabled":"TSK8kvWb","avatarTextSection":"SE-ibbuc","location":"N_eySy9e","positionCompanyName":"JMjWEz5B"};
    if(module.hot) {
      // 1746735834936
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  